import { CompType, isString } from '@aloft/toolkit-shared';
import { Block, Button, Flex, IconButton, Typography } from '@aloft/toolkit-sui';

import { CompTypeBadge } from '../../components/CompTypeBadge.tsx';
import { ToastOptions } from './types.ts';

export const RenderToast = ({
  title,
  body,
  compType,
  onClose,
  onClick,
  isClickable,
  action,
}: {
  title: ToastOptions['title'];
  body: ToastOptions['body'];
  compType?: CompType;
  onClose: VoidFunction;
  onClick?: VoidFunction;
  isClickable?: boolean;
  action?: {
    text: string;
    onClick: () => void;
  };
}) => {
  let paragraphs: string[] = [];
  if (Array.isArray(body)) {
    paragraphs = body;
  } else if (isString(body)) {
    paragraphs = [body];
  }

  return (
    <Flex alignItems="center">
      <Block
        flex={1}
        onClick={onClick}
        __dangerDoNotUseSx={{
          minWidth: 0,
          ...(isClickable ? { cursor: 'pointer' } : undefined),
        }}
      >
        <Typography variant="h4" __dangerDoNotUseSx={{ marginBottom: 1 }}>
          {title}
        </Typography>
        <Flex alignItems="flex-end">
          {paragraphs.map((x) => (
            <Typography key={x}>{x}</Typography>
          ))}
          {action && <Button text={action.text} onClick={action.onClick} marginLeft="1.5rem" />}
        </Flex>
      </Block>
      <Flex alignItems="flex-start" gap="8px">
        {compType && <CompTypeBadge compType={compType} />}
        <IconButton
          variant="tertiary"
          icon="close"
          size="xs"
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
          ariaLabel="Close alert"
        />
      </Flex>
    </Flex>
  );
};
